/** Date helpers shared by the host calendar (the page, the booking bars and the booked-night popup). Dates are YYYY-MM-DD. */

/** A Date as YYYY-MM-DD in local time (no timezone shift). */
export const formatDateString = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/** The YYYY-MM-DD part of a date or date-time string. */
export const toYmd = (raw: string | undefined | null): string | null => {
  if (!raw) return null;
  const s = String(raw);
  return s.length >= 10 ? s.slice(0, 10) : s;
};

export const addDays = (dateStr: string, n: number): string => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + n);
  return formatDateString(d);
};

export const nightsBetween = (from: string, to: string): number =>
  Math.round((new Date(`${to}T00:00:00`).getTime() - new Date(`${from}T00:00:00`).getTime()) / 86400000);

/** Booked nights as date keys: check-in night up to but not including check-out night. */
export const getOccupiedNightKeys = (checkInRaw: string, checkOutRaw?: string): string[] => {
  const startStr = toYmd(checkInRaw);
  if (!startStr) return [];
  const endExclusiveStr = toYmd(checkOutRaw || '') || startStr;
  const start = new Date(startStr + 'T00:00:00');
  const endExclusive = new Date(endExclusiveStr + 'T00:00:00');
  const dates: string[] = [];
  const cursor = new Date(start);
  if (endExclusive <= start) {
    return [startStr];
  }
  while (cursor < endExclusive) {
    dates.push(formatDateString(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return dates.length ? dates : [startStr];
};
